import { useEffect, useState } from 'react';
import { CookiebotJS } from '../types';

export function useCookiebot() {
  const [cookiebot, setCookiebot] = useState<CookiebotJS | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.Cookiebot) {
      return;
    }

    setCookiebot(window.Cookiebot);
  }, []);

  return cookiebot;
}
